import { Injectable } from '@angular/core';
import {
  DeviceTypeAddRequest,
  DeviceTypeResponse,
  DeviceTypeUpdateRequest,
} from '@entities/deviceType';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceTypeService {
  constructor(private api: ApiService) {}

  /**
   * デバイス種類一覧を取得する
   * @returns デバイス種類一覧
   */
  findAll(): Observable<DeviceTypeResponse[]> {
    const url = '/device-types';
    return this.api.get<DeviceTypeResponse[]>(url);
  }

  /**
   * デバイス種類を追加する
   * @param request 追加内容
   */
  add(request: DeviceTypeAddRequest): Observable<DeviceTypeAddRequest> {
    const url = '/device-types';
    return this.api.post<DeviceTypeAddRequest>(url, request);
  }

  /**
   * デバイス種類を更新する
   * @param request 更新内容
   */
  update(request: DeviceTypeUpdateRequest): Observable<DeviceTypeResponse> {
    const url = `/device-types/${request.deviceTypeKey}`;
    return this.api.put<DeviceTypeResponse>(url, request);
  }

  /**
   * デバイス種類を削除する
   * @param deviceTypeKey デバイス種類内部キー
   */
  delete(deviceTypeKey: string): Observable<void> {
    const url = `/device-types/${deviceTypeKey}`;
    return this.api.delete<void>(url);
  }
}
